import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true, // Ensure cookies are sent with each request
});

export default axiosInstance;